"use client";

import React from "react";
import { CircleCheck as CheckCircle2, Lightbulb, Target, BookOpen } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const expertsData = [{
  title: "Ketua Dewan Pakar",
  icon: Lightbulb,
  description: "Memimpin arah kajian dan strategi utama organisasi."
}, {
  title: "Wakil Ketua Dewan Pakar",
  icon: Target,
  description: "Membantu perumusan rekomendasi dan target strategis."
}, {
  title: "Anggota Dewan Pakar",
  icon: BookOpen,
  description: "Melakukan riset dan menyusun kajian mendalam."
}];
const coreTasks = ["Memberikan kajian", "Memberikan rekomendasi", "Memberikan pemikiran strategis"];
export default function DewanPakar() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="dewan-pakar" className="py-24 bg-background relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-0">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-lg bg-primary/5 blur-[120px]" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-foreground mb-6 uppercase font-default">
            Dewan Pakar
          </h2>
          <div className="w-24 h-1.5 bg-primary mx-auto mb-8 rounded-lg" />
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed">
            Badan strategis yang bertugas merumuskan pemikiran, kajian, dan rekomendasi untuk menjaga arah perjuangan dan kemajuan organisasi Pemuda Pancasila.
          </p>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto transition-all duration-700 delay-200 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {expertsData.map((expert, index) => {
          const Icon = expert.icon;
          return <Card key={index} data-index={index} className="border-t-4 border-t-primary rounded-xl shadow-md hover:shadow-lg transition-all duration-300 bg-card h-full flex flex-col group">
                <CardHeader className="text-center pb-6 pt-8">
                  <div className="mx-auto bg-primary/10 w-16 h-16 rounded-lg flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors duration-300">
                    <Icon className="w-8 h-8 text-primary" />
                  </div>
                  <CardTitle className="text-xl md:text-2xl font-bold uppercase tracking-wide text-foreground font-default mb-2">
                    {expert.title}
                  </CardTitle>
                  <p className="text-sm text-muted-foreground">
                    {expert.description}
                  </p>
                </CardHeader>
                
                <CardContent className="flex-grow flex flex-col">
                  <Separator className="mb-6 bg-border/60" />
                  <h4 className="text-xs font-bold text-secondary mb-5 uppercase tracking-widest text-center font-default">
                    Tugas Pokok
                  </h4>
                  <ul className="space-y-4 mt-auto">
                    {coreTasks.map((task, taskIndex) => <li key={taskIndex} data-index={taskIndex} className="flex items-start gap-3">
                        <CheckCircle2 className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                        <span className="text-sm md:text-base text-foreground/80 font-medium leading-snug">
                          {task}
                        </span>
                      </li>)}
                  </ul>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}